/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { renderComponent, renderBreakingNews, renderIsomorphicComponent } from "@quintype/framework/client/start";
import get from "lodash/get";
import { BreakingNewsView } from "../isomorphic/components/breaking-news/breaking-news-view";
import { pickComponent } from "../isomorphic/pick-component";
import { LoadingIndicatorComponent } from "../isomorphic/components/basic/loading-indicator.js";
import { pickHeader } from "../isomorphic/pick-header";
import { InjectWidget } from "../isomorphic/components/inject-widget";
import { MeteredStoryIndicator } from "../isomorphic/components/basic/metered-story-indicator/metered-story-indicator";
import { SSOWrapper } from "../isomorphic/components/sso-components/sso-dynamic";
import { AmazonPollyPopup } from "../isomorphic/components/amazon-polly/amazon-polly-popup";
import { pickFooter } from "../isomorphic/pick-footer";
import { PBThemeSettings } from "../isomorphic/components/pb-theme";
import DFPHelper from "../isomorphic/components/atoms/dfp-helper";
import { Metype } from "../isomorphic/components/molecules/metype";
export function preRenderApplication(store) {
  const storeConfig = get(store.getState(), ["qt", "config"], {});
  const themeAttributes = storeConfig["theme-attributes"];
  const pbConfig = storeConfig["pagebuilder-config"];
  const headerTheme = get(pbConfig, ["header", "headerStyle"], get(themeAttributes, ["header_theme"], "header_1"));
  const footerTheme = get(pbConfig, ["footer", "footerStyle"], get(themeAttributes, ["footer_theme"], "footer_1"));

  pickHeader(headerTheme).then(header => renderComponent(header.default, "navbar", store));
  pickFooter(footerTheme).then(footer => renderComponent(footer.default, "footer", store));

  if (!themeAttributes.hide_breaking_news) renderBreakingNews("breaking-news-container", store, BreakingNewsView);

  renderComponent(InjectWidget, "widget", store);
  renderComponent(PBThemeSettings, "pbTheme", store);

  const isEnableLiveFeed = get(
    pbConfig,
    ["general", "meType", "enableLiveFeed"],
    get(themeAttributes, ["metype-config", "enableLiveFeed"])
  );
  if (isEnableLiveFeed) global.setTimeout(() => renderComponent(Metype, "meType", store), 3000);
}

// This is a separate file as everything from here on is hot reloaded when the app changes
export function renderApplication(store) {
  const storeQTData = get(store.getState(), ["qt"], {});
  const storeConfig = get(storeQTData, ["config"], {});
  const pageType = get(storeQTData, ["pageType"], "");
  const pbConfig = storeConfig["pagebuilder-config"];
  if (global.location.hash === "#secret-mode") {
    const themeAttributes = storeConfig["theme-attributes"];
    const headerTheme = get(pbConfig, ["header", "headerStyle"], get(themeAttributes, ["header_theme"], "header_1"));
    const footerTheme = get(pbConfig, ["footer", "footerStyle"], get(themeAttributes, ["footer_theme"], "footer_1"));

    pickHeader(headerTheme).then(header => renderComponent(header.default, "navbar", store));
    pickFooter(footerTheme).then(footer => renderComponent(footer.default, "footer", store));

    import(/* webpackChunkName: "secret-mode" */ "./secret/secret-mode").then(({ startSecretMode }) =>
      startSecretMode(store)
    );
  }
  const lightRows = get(pbConfig, ["home", "lightRows"], false);
  if (pageType !== "home-page" || (pageType === "home-page" && !lightRows)) {
    renderIsomorphicComponent("container", store, pickComponent, { hydrate: !global.qtLoadedFromShell });
  }

  renderBreakingNews("breaking-news-container", store, BreakingNewsView);
  renderComponent(LoadingIndicatorComponent, "loading-indicator", store);

  renderComponent(DFPHelper, "dfp-helper", store);
  // TODO: Lazyload SSO
  renderComponent(SSOWrapper, "sso-wrapper", store);
  // TODO: Render only in story page.
  renderComponent(MeteredStoryIndicator, "metered-story-indicator", store);
  renderComponent(AmazonPollyPopup, "amazon-polly", store);
}
